<template>
    <div id="formAbonnement">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="details">
                        <h3  v-if="!envARLDE" >Mes abonnements</h3>
                        <h3  v-if="envARLDE">Meine Anmeldungen</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <FormAbonnement />
        </div>
    </div>
</template>

<script>
    import FormAbonnement from '../components/FormAbonnement.vue'
    import { reactive, computed } from 'vue'
    export default {
        name: 'FormAbonnementView',
        components: {
            FormAbonnement,
        },
        data() {
            return {
                envARLDE: false,
            }
        },
        created() {
            if (this.$route.params.c != '') {
                this.c = this.$route.params.c
                if(this.$route.params.c == 'c=ARLDE') {
                    this.envARLDE = true;
                }
            }
        }
    }
</script>
